import {
  TKwikUIInputDateRangeSize,
  VKwikUIInputDateRangeSize
} from "./input-date-range.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";
  const validateDate = (date: any): boolean => {
    return (
      date.hasOwnProperty("day") &&
      date.hasOwnProperty("month") &&
      date.hasOwnProperty("year")
    );
  };
  const validateDateLength = (date: any): boolean => {
    if (date == null) {
      return true;
    }
    if (
      date.hasOwnProperty("day") ||
      date.hasOwnProperty("month") ||
      date.hasOwnProperty("year")
    ) {
      return true;
    }
    return false;
  };

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    isShowLabelOutside: isBoolean,
    label: isString,
    max: validateDate,
    maxLength: validateDateLength,
    min: validateDate,
    minLength: validateDateLength,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    size: (x: TKwikUIInputDateRangeSize) =>
      VKwikUIInputDateRangeSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
